var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXCircleTransparent = function SvgXCircleTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18M0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11m7.293-3.707a1 1 0 0 1 1.414 0L11 9.586l2.293-2.293a1 1 0 1 1 1.414 1.414L12.414 11l2.293 2.293a1 1 0 0 1-1.414 1.414L11 12.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L9.586 11 7.293 8.707a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
export default SvgXCircleTransparent;